import Vue from 'vue';

export default {
    getEstatusIncidencias(parametros){
        return Vue.axios.get("catalogo/estatus-incidencias/find", {params: parametros}).then((response) => Promise.resolve(response.data)).catch((error) => Promise.reject(error));
    },
    getEstatusincidencia(id){
        return Vue.axios.get("catalogo/estatus-incidencias/" + id).then((response) => Promise.resolve(response.data)).catch((error) => Promise.reject(error));
    },
    updateEstatusincidencia(parametros){
        return Vue.axios.put("catalogo/estatus-incidencias", parametros ).then((response) => Promise.resolve(response.data)).catch((error) => Promise.reject(error));
    },
    deleteEstatusincidencia(id){
        return Vue.axios.delete("catalogo/estatus-incidencias/"+ id).then((response) => Promise.resolve(response.data)).catch((error) => Promise.reject(error));
    },
    addEstatusincidencia(parametros){
        return Vue.axios.post("catalogo/estatus-incidencias", parametros ).then((response) => Promise.resolve(response.data)).catch((error) => Promise.reject(error));
    }
}